import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dot-fill",
  templateUrl: "./med-icon-dot-fill.component.html",
})
export class MedIconDotFillComponent extends SvgMixinComponent {}
